"use client";

import Box from "@sendsprint/ui-react/components/box";
import React from "react";
import { postSubmitData } from "../../data/postSubmitData";
import useMailingList from "../../hooks/useMailingList";
import MailingListForm from "../mailingListForm";
import MailingListResponse from "../mailingListResponse";
import cs from "classnames";

interface Props {
  background?: "deep-green" | "light-green";
  isNewsletterPage?: boolean;
}

const MailingListContent = ({ background, isNewsletterPage }: Props) => {
  const mailingLogic = useMailingList();
  const { postSubmitState, handleResetPostSubmitState } = mailingLogic;

  return (
    <Box
      className={cs({
        "ss:text-white": background === "deep-green",
      })}
    >
      {postSubmitState ? (
        <MailingListResponse
          background={background}
          handleResetPostSubmitState={handleResetPostSubmitState}
          {...postSubmitData[postSubmitState]}
        />
      ) : (
        <MailingListForm
          isNewsletterPage={isNewsletterPage}
          background={background}
          mailingLogic={mailingLogic}
        />
      )}
    </Box>
  );
};

export default MailingListContent;
